/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef } from 'react'

/** Common Components */
import RenderTabs2 from '../../../../components/ui/tabs/RenderTabs2'

import { DocumentCategory, DocumentCategoryType } from '../../../../utils/ENUMS/documentCategory'

/** Utilities */
import Specifications from './features/specifications/Specifications'
import Address from './features/address/Address'
import Amendments from './features/amendments/Amendments'
import Affiliates from './features/affiliates/Affiliates'
import Documents from '../../../../common/features/documents/Documents'
import Departments from './features/contractDepartments/ContractDepartments'
import InvoicesOld from './features/contractInvoices-old/InvoicesOld'
import Scopes from './features/contractScopes/ContractScopes'
import Repairs from './features/contractRepairs/ContractRepairs'
import Renewal from './features/contractRenewal/ContractRenewal'
import Invoices from './features/contractInvoices/ContractInvoices'
import { ContractContext } from '../../../../utils/context/ContractContext'
import CommissionRates from './features/commissionRates/CommissionRates'
import ReportCard from './features/reportCard/ReportCard'
import Notes from '../../../../common/features/notes/note'
import { NewOwnerType } from '../../../../utils/ENUMS/OwnerTypes'
import ExpenseTrending from './features/contractExpenseTrending/features/ContractExpenseTrending'

const ContractMaintenancetab = (props) => {

    const {  contractId } = useContext(ContractContext);
    const specificationsRef = useRef();
    const addressesRef = useRef(null);

    useEffect(() => {
        if (props.isClicked) {
          let specificationsRefFormData = specificationsRef.current.getFormData();
            let addressesRefFormData = addressesRef.current.getFormData();
          if (props.isClicked && specificationsRefFormData && addressesRefFormData) {
            const responseRefData = {
                ...specificationsRefFormData,
                ...addressesRefFormData
            };
            props.onSaveClick(responseRefData);
          }
        }
      }, [props.isClicked]);
    
    
    const tabs = [

        {
            sMenuItemCaption: "Specifications",
            component: <Specifications ref={specificationsRef}  />,
            isDynamic: false
        },
        {
            sMenuItemCaption: "Address",
            component: <Address  ref={addressesRef} />,
            isDynamic: false
        },
        {
            sMenuItemCaption: "Departments",
            component: <Departments />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Scopes",
            component: <Scopes />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Repairs",
            component: <Repairs />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Notes",
            component: <Notes plOwnerKey={contractId} plOwnerTypeKey={NewOwnerType.CONTRACT} />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Amendments",
            component: <Amendments />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Renewal",
            component: <Renewal />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Invoices",
            component: <Invoices />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Affiliates",
            component: <Affiliates />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Documents",
            component: <Documents ownerKey={contractId} DocumentCategoryType={DocumentCategoryType.PAPERWORK_CONTRACT} DocumentCategory={DocumentCategory.CONTRACT} />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Expense Trending",
            component: <ExpenseTrending/>,
           // component: <UnderConstruction />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Report Card",
            component: <ReportCard />,
            isDynamic: true
        },
        {
            sMenuItemCaption: "Commission Rates",
            component: <CommissionRates />,
            isDynamic: true
        },
        // {
        //     sMenuItemCaption: "Invoices - Old",
        //     component: <InvoicesOld />,
        //     isDynamic: true
        // }
    ]
    return (
        <div>
            <RenderTabs2 tabs={tabs} />
        </div>

    )
}

export default ContractMaintenancetab